import React from "react";
import { connect } from "react-redux";
import { createEmployee } from "../../Redux/actions";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import withStyles from "@material-ui/core/styles/withStyles";
import * as Yup from "yup";
import {
  omitFields,
  convertToBase64,
  validateEmail,
  validateNationalId,
  validateNumber,
  validateName,
  calculateRatePerHour,
} from "@utils/utils";
import {
  Select,
  MenuItem,
  FormControl,
  FormControlLabel,
  Checkbox,
  InputLabel,
} from "@material-ui/core";
import { toast } from "react-toastify";
import CalculateRatePerHour from "./CalculateRPH";
import SelectPaymentMode from "./SelectModeOfPayment";
import { CONTRACTS, VEHICLE_TYPE } from "@utils/constants";
import { MODE_OF_PAYMENT } from "@utils/constants";
import { GENDERS } from "../../utils/constants";

const styles = (theme) => ({
  paper: {
    maxWidth: 1100,
    margin: "auto",
    overflow: "hidden",
    display: "flex",
    flexWrap: "wrap",
    padding: theme.spacing.unit,
  },
  form: {
    marginTop: theme.spacing.unit,
  },
  textField: {
    marginLeft: theme.spacing.unit * 2,
    marginRight: theme.spacing.unit * 2,
    marginTop: theme.spacing.unit * 2,
    width: 450,
  },
  submitButton: {
    margin: theme.spacing.unit,
    marginTop: theme.spacing.unit * 2,
  },
  switch: {
    marginTop: theme.spacing.unit * 3,
    marginLeft: theme.spacing.unit,
  },
  formControl: {
    marginTop: theme.spacing.unit * 2,
    marginLeft: theme.spacing.unit * 2,
    width: 450,
  },
});

class CreateUser extends React.Component {
  userSchema = Yup.object().shape({
    email: Yup.string()
      .email("The e-mail must be a valid email address.")
      .required("The e-mail field is required."),
  });

  constructor(props) {
    super(props);
    this.initialState = {
      email: null,
      smsCredentials: true,
      emailCredentials: true,
      isSubmitting: false,
      status: "Probationary",
      gender: "male",
      salary: "",
      machine_no: "",
      checkbox: false,
      perHourSalary: "", // Add hourlyRate field
      monthlyAssignedHours: "", // Add monthlyAssignedHoursfield
      role: "Admin",
      mode_of_payment: MODE_OF_PAYMENT[0],
      vehicle_type: VEHICLE_TYPE[0], // VEHICLE_TYPE[0] is none
      vehicle_no: "",
      validation: {
        personal_email: null,
        official_email: null,
        national_id_number: null,
        mobile_number: null,
        first_name: null,
        last_name: null,
        father_name: null,
        residential_number: null,
      },
    };

    this.state = this.initialState;
  }
  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState(
      {
        [name]: value,
      },
      () => {
        this.calculateRatePerHour(); // Calculate rate per hour after state update
      }
    );
  };

  calculateRatePerHour = () => {
    const { salary, monthlyAssignedHours } = this.state;

    const hourlyRate = calculateRatePerHour(salary, monthlyAssignedHours);

    this.setState({
      perHourSalary: hourlyRate,
    });
  };
  hasError = (field) => {
    return this.state.validation[field] != null;
  };

  isFormValid = () => {
    let isFormValid = true;
    let validationErrors = {
      personal_email: null,
      official_email: null,
      national_id_number: null,
      mobile_number: null,
      first_name: null,
      last_name: null,
      father_name: null,
      residential_number: null,
    };

    if (!validateName(this.state.first_name)) {
      validationErrors.first_name = "Only alphabets and spaces are allowed";
      isFormValid = false;
    }
    if (!validateName(this.state.last_name)) {
      validationErrors.last_name = "Only alphabets and spaces are allowed";
      isFormValid = false;
    }
    if (!validateName(this.state.father_name)) {
      validationErrors.father_name = "Only alphabets and spaces are allowed";
      isFormValid = false;
    }
    if (!validateNumber(this.state.residential_number)) {
      validationErrors.residential_number =
        "Invalid Residential Number. Number be like ####-#######";
      isFormValid = false;
    }
    if (!validateEmail(this.state.personal_email)) {
      validationErrors.personal_email = "Invalid Email Id";
      isFormValid = false;
    }
    if (!validateEmail(this.state.official_email)) {
      validationErrors.official_email = "Invalid Email Id";
      isFormValid = false;
    }
    if (!validateNationalId(this.state.national_id_number)) {
      validationErrors.national_id_number =
        "Invalid National Id. National Id Card No be like #####-#######-#";
      isFormValid = false;
    }
    if (!validateNumber(this.state.mobile_number)) {
      validationErrors.mobile_number =
        "Invalid Phone Number. Mobile No be like ####-#######";
      isFormValid = false;
    }
    this.setState({
      validation: validationErrors,
    });

    return isFormValid;
  };

  handleSubmit = async (event) => {
    event.preventDefault();

    if (!this.isFormValid()) {
      return;
    }

    this.setState({
      isSubmitting: true,
    });

    let data = {
      ...this.state,
      notifyBy: [],
    };
    let payload;
    if (!this.state.checkbox) {
      payload = omitFields(data, ["password", "role"]);
    }
    payload = omitFields(data, [
      "smsCredentials",
      "emailCredentials",
      "isSubmitting",
      "notifyBy",
      "checkbox",
    ]);
    if (this.state.image) {
      payload.image = await convertToBase64(this.state.image);
    }

    const result = await this.props.createEmployee(payload);
    const { message, success } = result.data;
    toast(message, {
      position: "bottom-left",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: false,
      pauseOnHover: false,
      draggable: false,
      progress: undefined,
      theme: "dark",
      type: success ? "success" : "error",
    });
    setTimeout(() => {
      if (success) {
        this.props.history.push("/employees");
      }
    }, 3000);
  };

  render() {
    const { classes } = this.props;
    return (
      <>
        <Paper className={classes.paper}>
          <form
            className={classes.form}
            autoComplete="off"
            onSubmit={this.handleSubmit}
          >
            <TextField
              id="first_name"
              name="first_name"
              label="First Name"
              fullWidth
              required
              error={this.hasError("first_name")}
              className={classes.textField}
              value={this.state.first_name}
              onChange={this.handleChange}
              helperText={this.state.validation.first_name}
              margin="normal"
            />
            <TextField
              id="last_name"
              name="last_name"
              label="Last Name"
              fullWidth
              required
              error={this.hasError("last_name")}
              className={classes.textField}
              value={this.state.last_name}
              onChange={this.handleChange}
              helperText={this.state.validation.last_name}
              margin="normal"
            />
            <TextField
              name="gender"
              label="Gender"
              fullWidth
              className={classes.textField}
              value={this.state.gender}
              onChange={this.handleChange}
              margin="normal"
              select
            >
              {GENDERS?.map((gender, index) => (
                <MenuItem key={index} value={gender.value}>
                  {gender.label}
                </MenuItem>
              ))}
            </TextField>
            <TextField
              id="father_name"
              name="father_name"
              label="Father Name"
              fullWidth
              required
              error={this.hasError("father_name")}
              className={classes.textField}
              value={this.state.father_name}
              onChange={this.handleChange}
              helperText={this.state.validation.father_name}
              margin="normal"
            />
            <TextField
              id="national_id_number"
              name="national_id_number"
              label="National ID Number"
              fullWidth
              required
              className={classes.textField}
              error={this.hasError("national_id_number")}
              value={this.state.national_id_number}
              onChange={this.handleChange}
              helperText={this.state.validation.national_id_number}
              margin="normal"
            />
            <TextField
              id="personal_email"
              name="personal_email"
              label="Personal Email"
              fullWidth
              required
              className={classes.textField}
              error={this.hasError("personal_email")}
              value={this.state.email}
              onChange={this.handleChange}
              helperText={this.state.validation.personal_email}
              margin="normal"
            />
            <TextField
              id="official_email"
              name="official_email"
              label="Official Email"
              fullWidth
              required
              className={classes.textField}
              error={this.hasError("official_email")}
              value={this.state.official_email}
              onChange={this.handleChange}
              helperText={this.state.validation.official_email}
              margin="normal"
            />
            <TextField
              id="mobile_number"
              name="mobile_number"
              label="Mobile No"
              fullWidth
              required
              className={classes.textField}
              error={this.hasError("mobile_number")}
              value={this.state.phone}
              onChange={this.handleChange}
              helperText={this.state.validation.mobile_number}
              margin="normal"
            />
            <TextField
              id="residential_number"
              name="residential_number"
              label="Residential Number"
              fullWidth
              required
              error={this.hasError("residential_number")}
              className={classes.textField}
              value={this.state.residential_number}
              onChange={this.handleChange}
              helperText={this.state.validation.residential_number}
              margin="normal"
            />

            <TextField
              id="residential_address"
              name="residential_address"
              label="Residential Address"
              type="text"
              fullWidth
              required
              className={classes.textField}
              value={this.state.residential_address}
              onChange={this.handleChange}
              margin="normal"
            />
            <TextField
              id="permanent_address"
              name="permanent_address"
              label="Permanent Address"
              fullWidth
              required
              className={classes.textField}
              value={this.state.permanent_address}
              onChange={this.handleChange}
              margin="normal"
            />
            <TextField
              id="date_of_birth"
              name="date_of_birth"
              label="Date Of Birth"
              type="date"
              required
              onChange={this.handleChange}
              className={classes.textField}
              InputLabelProps={{
                shrink: true,
              }}
            />
            <TextField
              id="joining_date"
              name="joining_date"
              label="Joining Date"
              type="date"
              required
              onChange={this.handleChange}
              className={classes.textField}
              InputLabelProps={{
                shrink: true,
              }}
            />

            <TextField
              id="contract_started_at"
              name="contract_started_at"
              label="Contract Starting Date"
              type="date"
              required
              value={this.state.contract_starting_date}
              onChange={this.handleChange}
              className={classes.textField}
              InputLabelProps={{
                shrink: true,
              }}
            />

            <TextField
              id="contract_ended_at"
              name="contract_ended_at"
              label="Contract Ending Date"
              type="date"
              required
              value={this.state.contract_ending_date}
              onChange={this.handleChange}
              className={classes.textField}
              InputLabelProps={{
                shrink: true,
              }}
            />

            <TextField
              id="job_title"
              name="job_title"
              label="Job Title"
              fullWidth
              required
              className={classes.textField}
              error={this.hasError("job_title")}
              value={this.state.job_title}
              onChange={this.handleChange}
              margin="normal"
            />
            <TextField
              name="status"
              label="Contract"
              fullWidth
              className={classes.textField}
              value={this.state.status}
              onChange={this.handleChange}
              margin="normal"
              select
            >
              {CONTRACTS.map((contract, index) => (
                <MenuItem key={index} value={contract}>
                  {contract}
                </MenuItem>
              ))}
            </TextField>

            <CalculateRatePerHour
              classes={classes}
              state={this.state}
              handleChange={this.handleChange}
              hourlyContract={this.state.status === "Hourly"}
            />
            <TextField
              id="medical_allowance"
              name="medical_allowance"
              label="Medical Allowance"
              fullWidth
              type="number"
              defaultValue={0}
              InputProps={{ inputProps: { min: 0 } }}
              className={classes.textField}
              value={this.state.medical_allowance}
              onChange={this.handleChange}
              margin="normal"
            />
            <TextField
              name="vehicle_type"
              label="Select Vehicle Type"
              fullWidth
              className={classes.textField}
              value={this.state.vehicle_type}
              onChange={this.handleChange}
              margin="normal"
              select
            >
              {VEHICLE_TYPE.map((type, index) => (
                <MenuItem key={index} value={type}>
                  {type}
                </MenuItem>
              ))}
            </TextField>
            {this.state.vehicle_type !== VEHICLE_TYPE[0] && ( // VEHICLE_TYPE[0] is none
              <TextField
                name="vehicle_no"
                label="Vehicle Number"
                fullWidth
                className={classes.textField}
                value={this.state.vehicle_no}
                onChange={this.handleChange}
                margin="normal"
              />
            )}

            <TextField
              id="machine_no"
              name="machine_no"
              label="Machine Number"
              fullWidth
              required
              className={classes.textField}
              defaultValue={this.state.machine_no}
              onChange={this.handleChange}
              margin="normal"
            />
            <SelectPaymentMode
              handleChange={this.handleChange}
              state={this.state}
              classes={classes}
              bankError={this.hasError("bank_name")}
              accountError={this.hasError("account_No")}
            />

            <FormControlLabel
              label="Upload Image"
              labelPlacement="start"
              className={classes.textField}
              control={
                <TextField
                  id="profile_pic"
                  name="profile_pic"
                  fullWidth
                  type="file"
                  InputProps={{ inputProps: { accept: "image/*" } }}
                  onChange={(e) => this.setState({ image: e.target.files[0] })}
                />
              }
            />
            <FormControlLabel
              label="Administrator"
              labelPlacement="end"
              className={classes.textField}
              control={
                <Checkbox
                  color="primary"
                  onChange={() =>
                    this.setState({ checkbox: !this.state.checkbox })
                  }
                />
              }
            />

            <br />
            {this.state.checkbox && (
              <>
                <FormControl className={classes.formControl}>
                  <InputLabel htmlFor="role">Role</InputLabel>
                  <Select
                    required={this.state.checkbox}
                    fullWidth
                    defaultValue={"Admin"}
                    onChange={this.handleChange}
                    inputProps={{
                      name: "role",
                      id: "role",
                    }}
                  >
                    <MenuItem value={"Admin"}>Admin</MenuItem>
                    <MenuItem value={"HR"}>HR</MenuItem>
                  </Select>
                </FormControl>
                <TextField
                  id="password"
                  name="password"
                  label="Password"
                  fullWidth
                  required={this.state.checkbox}
                  InputProps={{
                    autoComplete: "new-password",
                  }}
                  type="password"
                  className={classes.textField}
                  // error={this.hasError("")}
                  value={this.state.password}
                  onChange={this.handleChange}
                  margin="normal"
                />
              </>
            )}

            <br />
            <Grid
              container
              direction="column"
              justify="center"
              alignItems="flex-end"
            >
              <Grid item>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  className={classes.submitButton}
                >
                  Register
                </Button>
              </Grid>
            </Grid>
          </form>
        </Paper>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    posts: state.payload,
    users: state.users,
  };
};

export default connect(mapStateToProps, {
  createEmployee,
})(withStyles(styles)(CreateUser));
